import { Suspense, lazy, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router';

import '@bluecodecom/fonts';

import { LoaderProvider } from '@bluecodecom/loader';

import { ThemeProvider } from '@bluecodecom/theme';

import { nativeService } from '@bluecodecom/native';

import './i18n';

const App = lazy(() => import('./app'));

const Main = () => {
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    nativeService.hideNavigation();
    nativeService.allowResumeMiniApp();
  }, [language]);

  return (
    <LoaderProvider>
      <ThemeProvider observe>
        <BrowserRouter>
          <Suspense>
            <App />
          </Suspense>
        </BrowserRouter>
      </ThemeProvider>
    </LoaderProvider>
  );
};

createRoot(document.getElementById('root') as HTMLElement).render(<Main />);
